import {Component} from '@angular/core';
import {NavigationStart, Router} from '@angular/router';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'DMX3 Wetterportal';

  constructor(private router: Router, private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {

    // this.router.navigate(['']);
    //Um eigene SVG Icons für <mat-icon svgIcon=''></mat-icon> hinzuzufügen
    this.matIconRegistry.addSvgIcon('thermometer', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icon/thermometer_icon.svg'));
    this.matIconRegistry.addSvgIcon('thermometer_min', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icon/thermometer_min_icon.svg'));
    this.matIconRegistry.addSvgIcon('thermometer_max', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icon/thermometer_max_icon.svg'));
  }

  ngOnInit() {

  }
}

